import { AfterViewInit, Component, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import { ShiveRoutes } from '../../../../core/routing/segments/route-segments';
import { UserOperation } from '../../../../core/enums/user-operation';
import { faHandHoldingUsd } from '@fortawesome/pro-solid-svg-icons';
import { ProjectExpenseModel } from '../../../../core/models/finance/expense.model';
import { faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { ShiveGridWrapperComponent } from '../../../../shared/components/shive-controls/shive-grid/shive-grid-wrapper.component';
import { SubSink } from 'subsink';
import { ProjectExpensesGridService } from './project-expenses-grid.service';

@Component({
  selector: 'app-project-expenses',
  templateUrl: './project-expenses.component.html',
  standalone: false,
})
export class ProjectExpensesComponent implements OnInit, AfterViewInit, OnDestroy {
  gridWrapperComponent = viewChild<ShiveGridWrapperComponent>('gridWrapperComponent');

  // Constants
  public readonly ShiveRoutes = ShiveRoutes;
  public readonly UserOperation = UserOperation;
  public readonly faHandHoldingUsd = faHandHoldingUsd;

  // Getter / Setter
  public get gridData(): ProjectExpenseModel[] {
    return this.projectExpensesGridService.gridData();
  }

  // DI
  private readonly projectExpensesGridService = inject(ProjectExpensesGridService);

  // Misc
  private readonly subs = new SubSink();

  ngOnInit(): void {
    this.projectExpensesGridService.fetchProjectExpenses();
  }

  ngAfterViewInit(): void {
    this.initContextMenuCallbacks();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public openExpensesDialog(operation: UserOperation): void {
    this.projectExpensesGridService.openExpenseDialog(operation);
  }

  private initContextMenuCallbacks(): void {
    this.gridWrapperComponent().contextMenuItems = [
      {
        text: 'Bearbeiten',
        faIcon: faPen,
        callback: (projectExpenseRow: ProjectExpenseModel) =>
          this.projectExpensesGridService.openExpenseDialog(
            UserOperation.Update,
            projectExpenseRow,
          ),
        isVisible: true,
        isActivated: true,
      },
      {
        text: 'Löschen',
        faIcon: faTrash,
        callback: (projectExpenseRow: ProjectExpenseModel) => {
          this.projectExpensesGridService.deleteExpenseRow(projectExpenseRow);
        },
        isVisible: true,
        isActivated: true,
        iconColorClass: 'red',
      },
    ];
  }
}
